import { Component, AfterViewInit, ChangeDetectorRef, AfterViewChecked, OnInit } from '@angular/core';
import { FiltroReserva, Paginacao, STATUSRESERVA } from '../../model';
import { ReservaService, UsuarioService, LoginService } from '../../services/';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { event } from 'jquery';

@Component({
  selector: 'meus-orcamentos',
  templateUrl: './meus-orcamentos.component.html',
  styleUrls: ['./meus-orcamentos.component.scss']
})
export class MeusOrcamentosComponent implements AfterViewInit{

  filtro: FiltroReserva = new FiltroReserva();
  orcamentos = [];
  paginacao: Paginacao = new Paginacao();

  toogle = true;

  usuarioLogado: any;
  dataAtual = moment();

  data = [];

  Data3 = moment().add(-2, "months");
  Data4 = moment();

  Consultor: any = { Nome: '' };

  itemReserva: any;
  orcamentosClone: any;
  filtroPax: boolean = false;

  mensagemErro: string = "";

  erroAoBuscar: boolean = false;

  constructor(public router: Router, private reservaService: ReservaService, private usuarioService: UsuarioService, private loginService: LoginService, private modalService: NgbModal, private cdRef: ChangeDetectorRef) {
  }

  ngAfterViewInit() {
    this.usuarioLogado = this.loginService.user();
    this.buscarMeusOrcamentos();
  }

  // Filtro de datas
  setDate(event, ida: boolean = true) {
    if (ida) {
      this.filtro.Data1 = moment(event).startOf('day').toISOString()
      this.filtro.Data2 = moment(this.Data4).endOf('day').toISOString()
    } else {
      this.filtro.Data1 = moment(this.Data3).startOf('day').toISOString()
      this.filtro.Data2 = moment(event).endOf('day').toISOString()
    }
  }

  buscarMeusOrcamentos() {

    this.mensagemErro = "";

    this.filtroPax = false;
    let agencia = window.localStorage.getItem('g8h7d8');
    if (agencia != null) {
      let a = JSON.parse(atob(agencia));
      this.filtro.AgenciaId = a.Id;
    } else {
      this.filtro.AgenciaId = 0;
    };

    if (this.Consultor.Nome.length == 0) {
      this.filtro.ConsultorId = null;
    }

    if (this.Data3 && this.Data4) {
      this.filtro.Data1 = moment(this.Data3).startOf('day').toISOString();
      this.filtro.Data2 = moment(this.Data4).endOf('day').toISOString();
    }

    this.reservaService.buscarMeusOrcamentos(this.filtro, this.paginacao.NumeroPagina).subscribe(
      dados => {
        this.paginacao.NumeroPagina = dados.MetaData.NumeroPagina;
        this.paginacao.TotalItens = dados.MetaData.TotalItens;
        this.paginacao.ItensPorPagina = dados.MetaData.itensPorPagina;
        this.paginacao.TotalPaginas = dados.MetaData.TotalPaginas;

        this.orcamentos = dados.Items;

        if (this.orcamentos.length == 0 && this.erroAoBuscar) {
          if (this.paginacao.TotalItens == 0) {
            this.mensagemErro = "Nenhum orçamento encontrado"
          } else {
            this.mensagemErro = "Ocorreu um erro ao buscar os dados."
          }
        }
      },
      erro => { 
        console.log(erro)
        if (this.erroAoBuscar) {
          this.mensagemErro = erro.error.Message;
        }
       },
    );
  }

  filtrarPax(event) {
    if (event) {
      this.orcamentosClone = this.orcamentos;
      this.orcamentos = this.orcamentos.filter(x => x.Pax.length > 3);
    } else {
      this.orcamentos = this.orcamentosClone;
    }
  }

  // filtroStatus(status){

  //     if (this.filtroStatusChecked(status)){
  //       this.filtro.situacao = this.filtro.situacao.filter(x => x != status);
  //     }else{
  //       this.filtro.situacao.push(status);
  //     }
  //     if (this.filtroStatusChecked('-1')){
  //       this.filtro.situacao = [];
  //     }


  // }

  // filtroStatusChecked(status){
  //   return this.filtro.situacao.indexOf(status) >= 0;
  // }

  abrirModal(content, item) {
    this.itemReserva = item;
    this.modalService.open(content, { centered: true });
  };

  buscarPagina(pagina) {
    document.querySelector('.scrollable-container').scrollTop = 0;
    this.paginacao.NumeroPagina = pagina;
    this.buscarMeusOrcamentos();
  }


  acessarOrcamento(reserva) {
    // console.log(reserva);
    // console.log(this.router);
    this.router.navigate([`/turismo/orcamento/${reserva.Id}`]);

  }

  selecionaConsultor(item) {
    this.Consultor = item;
    this.filtro.ConsultorId = item.Id;
  }

  onChangeConsultor(val: string) {
    let empresaId = this.usuarioLogado.EmpresaId > 0 ? this.usuarioLogado.EmpresaId : 0;
    this.usuarioService.buscarConsultor(0, val, empresaId).subscribe(
      (dados) => {
        this.data = dados.map(function (x) {
          x.display_field = x.Nome + " (" + x.Email + ")";
          return x;
        });
      },
      (erro) => {
        console.log(erro);
        this.data = [];
      }
    );
  }

  statusProdutosReservados(produtos) {
    return produtos.every(x => x.Status == 3 || x.Status == 5);
  }

  statusProdutosComProblema(produtos) {
    return produtos.some(x => x.Status == 10 || x.Status == 7);
  }

}
